import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigation } from 'react-router-dom';

import Spinner from '@/components/Spinner';
import { useShallowEqualSelector } from '@/hooks';
import routes from '@/routes';
import { fetchUser } from '@/store/profile/thunks';

import NoIndexMeta from '../NoIndexMeta';
import { useLayout } from '../hooks';
import Header from './Header';

function CheckoutLayout() {
	const dispatch = useDispatch();
	const navigation = useNavigation();

	const { loggedIn, fetchUserCompleted } = useShallowEqualSelector(
		({ profile }) => ({
			loggedIn: profile.loggedIn,
			fetchUserCompleted: profile.fetchUser.completed
		})
	);

	const currentStep = useSelector(state => state.checkout.step);
	useLayout();

	useEffect(() => {
		if (!fetchUserCompleted || !loggedIn || !currentStep) {
			dispatch(fetchUser());
		}
	}, []);

	if (fetchUserCompleted && !loggedIn) {
		return <Navigate to="/" />;
	}

	if (
		(!fetchUserCompleted && !loggedIn) ||
		(navigation.state === 'loading' &&
			navigation.location?.pathname === routes.checkout)
	) {
		return (
			<>
				<Header />
				<NoIndexMeta />
				<div className="h-[calc(100svh-48px)] lg:h-[calc(100svh-64px)]" />
				<Spinner className="absolute inset-0 m-auto" size={50} />
			</>
		);
	}

	return (
		<>
			<NoIndexMeta />
			<Header />
			<div className="min-h-[calc(100svh-48px)] bg-grey-100 lg:min-h-[calc(100svh-64px)]">
				<Outlet />
			</div>
		</>
	);
}

export default CheckoutLayout;
